import React, { useEffect } from "react";
import { Button, Paper } from "@mui/material";

const FloatingNavBar = (props) => {
  const { selectedCategory, setSelectedCategory,categoryList } = props;


  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  return (
    <Paper
      elevation={3}
      sx={{
        position: "fixed",
        bottom: 20,
        zIndex: 3,
        left: "50%",
        transform: "translateX(-50%)",
        display: "flex",
        gap: 2,
        background: "rgba(0, 0, 0, 0.16)",
        borderRadius: "20px",
        backdropFilter: "blur(15px)",
        padding: "8px 17px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
      }}
    >
      {categoryList.map((item) => (
        <Button
          key={item}
          onClick={() => handleCategoryChange(item)}
          sx={{
            padding: "13px 17px",
            color: selectedCategory === item ? "#FFFFFF" : "#BEBEBE",
            backgroundColor:
              selectedCategory === item
                ? "rgba(0,0,0,0.3)"
                : "transparent",
            borderRadius: "14px",
            textTransform: "none",
            fontWeight: "400",
            fontFamily: "Poppins",
            transition: "all 0.3s ease",
            "&:hover": {
              background: "rgba(0,0,0,0.1)",
            },
          }}
        >
          {item}
        </Button>
      ))}
    </Paper>
  );
};

export default FloatingNavBar;
